import React, { useState } from 'react';
import { motion } from 'framer-motion';

const Home = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);

  const handleBookClick = (e) => {
    e.preventDefault();
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), 5000);
  };

  const openModal = (item) => {
    setSelectedItem(item);
    setModalOpen(true);
  };

  const closeModal = () => {
    setModalOpen(false);
    setSelectedItem(null);
  };

  const services = [
    {
      title: "Luminothérapie Corps ou / & Visage",
      subtitle: "Pour illuminer votre peau... et votre énergie intérieure",
      background: "linear-gradient(135deg, #fdf4e8 0%, #fce8d5 100%)",
      items: [
        {
          name: "Séance Luminothérapie – 30 min",
          price: 20,
          img: "5.jpg",
          shortBenefits: ["Amélioration du teint et texture", "Effet bonne mine immédiat", "Réduction du stress", "Recharge énergétique"],
          longDescription: "Amélioration du teint et de la texture de la peau • Effet bonne mine immédiat • Réduction du stress et des tensions • Recharge énergétique naturelle",
          contraindications: [
            "Photosensibilité ou traitement photo-sensibilisant",
            "Antécédents de mélanome ou épilepsie photosensible",
            "Troubles oculaires graves",
            "Grossesse (avis médical)"
          ]
        },
        {
          name: "Séance + Soin – 30 min",
          price: 30,
          img: "6.jpg",
          shortBenefits: ["Duo puissant pour booster l’éclat", "Résultat visible"],
          longDescription: "Un duo puissant pour booster l’éclat. Moment de détente",
          contraindications: ["Peau lésée", "Allergie aux produits"]
        },
        {
          name: "Forfait 5 séances",
          price: 120,
          img: "7.jpg",
          shortBenefits: ["Cure visible", "Peau plus lisse", "Vitalité"],
          longDescription: "Idéal en cure pour résultats visibles • Atténuation des imperfections • Peau plus lisse et lumineuse • Meilleure vitalité générale",
          contraindications: []
        },
        {
          name: "Forfait 10 séances",
          price: 240,
          img: "lumino2.jpg",
          shortBenefits: ["Anti-rides", "Sommeil amélioré", "Bien-être"],
          longDescription: "Réduction des rides et ridules • Régénération cutanée • Détente mentale prolongée • Amélioration du sommeil, de l’humeur, et du bien-être général",
          contraindications: []
        }
      ]
    },
    {
      title: "Pressothérapie",
      subtitle: "Drainage – Détox – Légèreté – Silhouette",
      background: "linear-gradient(135deg, #e8f5f0 0%, #d0f0e8 100%)",
      items: [
        {
          name: "Jambes – 30 min",
          price: 40,
          img: "1.jpg",
          shortBenefits: ["Circulation boostée", "Jambes légères", "Anti-cellulite", "Recupération musculaire"],
          longDescription: "Améliore la circulation veineuse et lymphatique • Soulage la sensation de jambes lourdes • Réduit les gonflements, œdèmes et varices légères • Atténue la cellulite aqueuse et raffermit la peau",
          contraindications: ["Thrombose", "Infection", "Insuffisance cardiaque"]
        },
        {
          name: "Bras – 30 min",
          price: 40,
          img: "2.jpg",
          shortBenefits: ["Détox bras", "Récupération musculaire"],
          longDescription: "Drainage des toxines accumulées • Réduction de la rétention d’eau • Raffermissement potentiel de la peau • Aide à la récupération après effort physique",
          contraindications: []
        },
        {
          name: "Ventre – 30 min",
          price: 40,
          img: "3.webp",
          shortBenefits: ["Transit stimulé", "Ventre plat"],
          longDescription: "Stimulation du système digestif et du transit • Réduction des ballonnements • Action sur la graisse localisée (en complément d’une alimentation équilibrée) • Effet gainant et tonifiant de la zone abdominale",
          contraindications: ["Grossesse", "Hernie"]
        },
        {
          name: "Forfait 5 séances",
          price: 120,
          img: "4.jpg",
          shortBenefits: ["Cure détox", "Silhouette affinée"],
          longDescription: "Débuter une cure détox • Préparer le corps à une perte de poids • Rebooster la circulation en période de fatigue • Ou tout simplement vous accorder un moment rien qu’à vous",
          contraindications: []
        }
      ]
    },
    {
      title: "Aromathérapie",
      subtitle: "Huiles essentielles – Équilibre – Relaxation – Énergie",
      background: "linear-gradient(135deg, #f9e4d4 0%, #fce8e8 100%)",
      items: [
        {
          name: "Séance seule – 30 min",
          price: 20,
          img: "9.jpg",
          shortBenefits: ["Stress ↓", "Sommeil ↑", "Énergie"],
          longDescription: "Apaisement du stress et de l’anxiété • Stimulation des défenses naturelles • Purification du corps et de l’esprit • Amélioration du sommeil et de la concentration",
          contraindications: ["Allergie", "Asthme", "Épilepsie"]
        },
        {
          name: "+ Massage – 30 min",
          price: 30,
          img: "10.jpg",
          shortBenefits: ["Détente musculaire", "Mental apaisé"],
          longDescription: "Relâcher les tensions musculaires • Apaiser le mental en profondeur • Revitaliser le corps en douceur",
          contraindications: []
        },
        {
          name: "+ Massage – 60 min",
          price: 45,
          img: "11.jpg",
          shortBenefits: ["Équilibre émotionnel", "Circulation"],
          longDescription: "Détente musculaire profonde • Amélioration de la circulation • Équilibre émotionnel • Purification du corps",
          contraindications: []
        },
        {
          name: "+ Massage + Soin Visage – 60 min",
          price: 50,
          img: "12.jpg",
          shortBenefits: ["Éclat du teint", "Hydratation"],
          longDescription: "Réveiller l’éclat du teint • Réhydrater et apaiser la peau • Relancer la circulation énergétique • Ressortir détendu(e) et rayonnant(e)",
          contraindications: ["Peau lésée", "Allergie"]
        }
      ]
    },
    {
      title: "Formule Anti-Stress",
      subtitle: "Respirez. Relâchez. Reconnectez-vous.",
      background: "linear-gradient(135deg, #f0f4e8 0%, #e8f5e8 100%)",
      items: [
        {
          name: "Flash – 15 min",
          price: 20,
          img: "13.jpg",
          shortBenefits: ["Calme instantané", "Clarté mentale"],
          longDescription: "Apaise immédiatement les tensions • Calme le mental • Redonne de l’élan et de la clarté",
          contraindications: []
        },
        {
          name: "Classique – 30 min",
          price: 30,
          img: "14.jpg",
          shortBenefits: ["Légèreté physique & mentale", "Sommeil"],
          longDescription: "Détente musculaire • Apaisement nerveux • Meilleure qualité de sommeil • Sensation de légèreté physique et mentale",
          contraindications: []
        },
        {
          name: "Longue – 60 min",
          price: 50,
          img: "15.jpg",
          shortBenefits: ["Relaxation profonde", "Équilibre émotionnel"],
          longDescription: "Relaxation profonde et durable • Harmonisation du corps et de l’esprit • Élimination du stress accumulé • Rééquilibrage émotionnel",
          contraindications: []
        },
        {
          name: "Forfait 5 séances",
          price: 120,
          img: "16.jpg",
          shortBenefits: ["Anti-burnout", "Sommeil réparateur"],
          longDescription: "Gestion du stress au travail ou dans la vie perso • Amélioration du sommeil • Soulagement des tensions corporelles • Prévention du burn-out • Se reconnecter à soi-même",
          contraindications: []
        }
      ]
    }
  ];

  return (
    <div style={styles.container}>
      {/* HERO */}
      <section style={styles.hero}>
        <div style={styles.heroOverlay} />
        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }} style={styles.heroContent}>
          <img src="/images/logo.png" alt="by-KZ" style={styles.logo} />
          <h1 style={styles.heroTitle}>by-KZ</h1>
          <p style={styles.heroSubtitle}>Éclat • Détente • Énergie</p>
          <a href="#" onClick={handleBookClick} style={styles.heroButton}>Réserver une séance</a>
        </motion.div>
      </section>

      {/* SERVICES */}
      <section style={styles.section}>
        <motion.h2 initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} style={styles.sectionTitle}>Nos Prestations</motion.h2>

        {services.map((service, idx) => (
          <motion.div
            key={idx}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: idx * 0.15 }}
            style={{ ...styles.serviceBlock, background: service.background }}
          >
            <h3 style={styles.blockTitle}>{service.title}</h3>
            <p style={styles.blockSubtitle}>{service.subtitle}</p>

            <div style={styles.itemsGrid}>
              {service.items.map((item, i) => (
                <motion.div key={i} whileHover={{ scale: 1.03 }} style={styles.itemCard}>
                  <div style={styles.itemImageWrapper}>
                    <img
                      src={`/images/${item.img}`}
                      alt={item.name}
                      style={styles.itemImage}
                      onError={(e) => (e.currentTarget.src = '/images/placeholder.jpg')}
                    />
                  </div>

                  <div style={styles.itemContent}>
                    <h4 style={styles.itemName}>{item.name}</h4>
                    <p style={styles.itemPrice}>{item.price}€</p>

                    <ul style={styles.benefits}>
                      {item.shortBenefits.map((b, j) => (
                        <li key={j} style={styles.benefit}> {b}</li>
                      ))}
                    </ul>

                    <button onClick={() => openModal(item)} style={styles.infoBtn}>
                      Plus d'infos
                    </button>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        ))}
      </section>

      {/* CONTACT */}
      <section style={styles.contactSection}>
        <h2 style={styles.contactTitle}>Contactez-nous</h2>
        <div style={styles.contactInfo}>
          <p>📞 <a href="tel:0678205080" style={styles.link}>06 78 20 50 80</a></p>
          <p>📍 1 place de la bastille, 91150 Étampes</p>
          <p>✉️ <a href="mailto:contact@by-kz.fr" style={styles.link}>contact@by-kz.fr</a></p>
        </div>
      </section>

      {/* FOOTER */}
      <footer style={styles.footer}>
        <p>© 2025 by-KZ • Tous droits réservés</p>
      </footer>

      {/* POP-UP RÉSERVATION */}
      {showPopup && (
        <motion.div initial={{ opacity: 0, scale: 0.8 }} animate={{ opacity: 1, scale: 1 }} style={styles.popup}>
          <div style={styles.popupContent}>
            <h3>La réservation en ligne arrive bientôt !</h3>
            <p>Contactez-nous au <strong>06 78 20 50 80</strong></p>
            <button onClick={() => setShowPopup(false)} style={styles.closeBtn}>✕</button>
          </div>
        </motion.div>
      )}

      {/* MODALE DÉTAILS */}
      {modalOpen && selectedItem && (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} style={styles.modalOverlay} onClick={closeModal}>
          <motion.div
            initial={{ y: 50, opacity: 0 }}
            animate={{ y: 0, opacity: 1 }}
            style={styles.modalContent}
            onClick={(e) => e.stopPropagation()}
          >
            <button onClick={closeModal} style={styles.modalClose}>✕</button>

            <h3 style={styles.modalTitle}>{selectedItem.name}</h3>
            <p style={styles.modalPrice}>{selectedItem.price}€</p>

            <img
              src={`/images/${selectedItem.img}`}
              alt={selectedItem.name}
              style={styles.modalImg}
              onError={(e) => (e.currentTarget.src = '/images/placeholder.jpg')}
            />

            <div style={styles.modalSection}>
              <h4 style={styles.modalSubtitle}>Bienfaits</h4>
              <p style={styles.modalText}>{selectedItem.longDescription}</p>
            </div>

            {selectedItem.contraindications && selectedItem.contraindications.length > 0 && (
              <div style={styles.modalSection}>
                <h4 style={styles.modalSubtitle}>Contre-indications</h4>
                <ul style={styles.modalList}>
                  {selectedItem.contraindications.map((c, i) => (
                    <li key={i} style={styles.modalListItem}> {c}</li>
                  ))}
                </ul>
                <p style={styles.modalNote}>En cas de doute, contactez nous.</p>
              </div>
            )}

            <button onClick={handleBookClick} style={styles.modalBookBtn}>Réserver</button>
          </motion.div>
        </motion.div>
      )}
    </div>
  );
};

const styles = {
  container: { fontFamily: "'Inter', sans-serif", backgroundColor: '#fffaf0', color: '#333' },
  hero: {
    position: 'relative',
    height: '80vh',
    backgroundImage: 'url(/images/candle.jpg)',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  heroOverlay: {
    position: 'absolute',
    inset: 0,
    background: 'linear-gradient(45deg, rgba(212,165,116,.6), rgba(168,230,207,.5))',
  },
  heroContent: { textAlign: 'center', zIndex: 2 },
  logo: { width: '180px', marginBottom: '1rem' },
  heroTitle: { fontSize: '4.5rem', color: '#fff', fontWeight: 800, margin: '0.5rem 0' },
  heroSubtitle: { fontSize: '1.5rem', color: '#fff', fontStyle: 'italic', marginBottom: '2rem' },
  heroButton: {
    padding: '14px 40px',
    backgroundColor: '#a8e6cf',
    color: '#fff',
    borderRadius: '50px',
    fontWeight: 700,
    textDecoration: 'none',
    fontSize: '1.1rem',
    boxShadow: '0 6px 20px rgba(168,230,207,.4)',
    transition: 'all .3s',
  },
  section: { padding: '100px 20px', maxWidth: '1400px', margin: '0 auto' },
  sectionTitle: { fontSize: '3rem', color: '#d4a574', textAlign: 'center', marginBottom: '4rem', fontWeight: 700 },
  serviceBlock: { borderRadius: '24px', padding: '3rem', marginBottom: '4rem', boxShadow: '0 10px 30px rgba(0,0,0,.05)' },
  blockTitle: { fontSize: '2.2rem', color: '#d4a574', textAlign: 'center', marginBottom: '0.5rem' },
  blockSubtitle: { textAlign: 'center', color: '#666', fontStyle: 'italic', marginBottom: '2.5rem' },
  itemsGrid: { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: '2rem' },
  itemCard: {
    background: '#fff',
    borderRadius: '20px',
    overflow: 'hidden',
    boxShadow: '0 8px 25px rgba(0,0,0,.08)',
    transition: 'transform .3s',
  },
  itemImageWrapper: { height: '180px', overflow: 'hidden' },
  itemImage: { width: '100%', height: '100%', objectFit: 'cover' },
  itemContent: { padding: '1.5rem' },
  itemName: { fontSize: '1.15rem', fontWeight: 600, color: '#333', marginBottom: '0.5rem' },
  itemPrice: { fontSize: '1.4rem', fontWeight: 700, color: '#a8e6cf', marginBottom: '1rem' },
  benefits: { margin: '0 0 1.5rem', padding: 0, fontSize: '0.9rem', color: '#555' },
  benefit: { marginBottom: '0.4rem' },
  infoBtn: {
    display: 'block',
    width: '100%',
    backgroundColor: '#d4a574',
    color: '#fff',
    padding: '10px',
    borderRadius: '12px',
    border: 'none',
    fontWeight: 600,
    cursor: 'pointer',
  },
  contactSection: { backgroundColor: '#d4a574', color: '#fff', padding: '80px 20px', textAlign: 'center' },
  contactTitle: { fontSize: '2.5rem', marginBottom: '2rem' },
  contactInfo: { fontSize: '1.2rem', lineHeight: 2 },
  link: { color: '#a8e6cf', textDecoration: 'none', fontWeight: 600 },
  footer: { backgroundColor: '#333', color: '#fff', textAlign: 'center', padding: '2rem', fontSize: '0.9rem' },
popup: {
  position: 'fixed',
  inset: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 1000,
  padding: '20px'
},

  popupContent: {
    backgroundColor: '#fff',
    padding: '2rem',
    borderRadius: '20px',
    textAlign: 'center',
    boxShadow: '0 20px 40px rgba(0,0,0,.2)',
    position: 'relative',
    border: '3px solid #a8e6cf',
  },
  closeBtn: { position: 'absolute', top: '10px', right: '15px', background: 'none', border: 'none', fontSize: '1.5rem', cursor: 'pointer', color: '#999' },
  modalOverlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,.6)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 999 },
  modalContent: {
    background: '#fff',
    maxWidth: '600px',
    width: '90%',
    maxHeight: '90vh',
    overflowY: 'auto',
    borderRadius: '20px',
    padding: '2rem',
    position: 'relative',
    boxShadow: '0 20px 40px rgba(0,0,0,.2)',
  },
  modalClose: { position: 'absolute', top: '15px', right: '20px', background: 'none', border: 'none', fontSize: '1.8rem', cursor: 'pointer', color: '#aaa' },
  modalTitle: { fontSize: '1.8rem', color: '#d4a574', marginBottom: '0.5rem', textAlign: 'center' },
  modalPrice: { fontSize: '1.5rem', color: '#a8e6cf', fontWeight: 700, textAlign: 'center', marginBottom: '1rem' },
  modalImg: { width: '100%', borderRadius: '12px', marginBottom: '1.5rem' },
  modalSection: { marginBottom: '1.5rem' },
  modalSubtitle: { fontSize: '1.2rem', color: '#d4a574', marginBottom: '0.5rem' },
  modalText: { fontSize: '1rem', lineHeight: 1.6, color: '#555' },
  modalList: { paddingLeft: '1.2rem', margin: '0.5rem 0' },
  modalListItem: { marginBottom: '0.4rem', color: '#d9534f' },
  modalNote: { fontStyle: 'italic', color: '#777', fontSize: '0.9rem', marginTop: '0.5rem' },
  modalBookBtn: {
    display: 'block',
    width: '100%',
    backgroundColor: '#a8e6cf',
    color: '#fff',
    padding: '12px',
    borderRadius: '12px',
    border: 'none',
    fontWeight: 600,
    cursor: 'pointer',
    marginTop: '1rem',
  },
};

export default Home;